import React, { useEffect, useRef, useState } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { getContactFormEntryById } from "../../../services/ContactFormEntryService";

const ViewContactFormEntry = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      const fetchEntry = async () => {
        try {
          const response = await getContactFormEntryById(id);
          setEntry(response.data.data);
        } catch (error) {
          console.error("Error fetching entry:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchEntry();
    }
  }, [id]);

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  if (!entry) {
    return (
      <div className="text-center mt-5">
        <p>Contact Form Entry not found.</p>
        <button
          className="btn btn-primary"
          onClick={() => {
            navigate("/contact-form-entry", {
              state: {
                page: location.state?.page || 1,
                searchTerm: location.state?.searchTerm || "",
              },
            })
          }}
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu="View Contact Form Entry"
        motherMenu="Contact Form Entries"
        activeMenuLink={`contact-form-entry/view/${id}`}
        motherMenuLink={"contact-form-entry"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div
                  className="d-flex align-items-center gap-2 cursor-pointer"
                  onClick={() => {
                    navigate("/contact-form-entry", {
                      state: {
                        page: location.state?.page || 1,
                        searchTerm: location.state?.searchTerm || "",
                      },
                    })
                  }}
                >
                  <i className="fas fa-chevron-left"></i>
                  <span>Contact Form Entry List</span>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">Full Name</label>
                <p className="form-control-plaintext">{entry.full_name}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Email</label>
                <p className="form-control-plaintext">{entry.email}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Mobile</label>
                <p className="form-control-plaintext">{entry.mobile || "-"}</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">
                  Preferred Service / Destination
                </label>
                <p className="form-control-plaintext">
                  {entry.preferred_plan || "-"} / {entry.preferred_destination || "-"}
                </p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Preferred Year</label>
                <p className="form-control-plaintext">
                  {entry.preferred_year || "-"}
                </p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Consent Given</label>
                <p className="form-control-plaintext">
                  {entry.consent_enable ? "Yes" : "No"}
                </p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Country</label>
                <p className="form-control-plaintext">
                  {entry.country_name || "-"}
                </p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Submitted On</label>
                <p className="form-control-plaintext">
                  {new Date(entry.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewContactFormEntry;
